import { Button, Form, Input, Modal, Card, Table, Typography } from "antd";
import React from "react";
import "./ImportErrorModal.less";
import { useHistory } from "react-router";
import { CustIcon } from "../../Svgs";

const { Title } = Typography;

export const ImportErrorModal = ({errorDetail, visible, closeModal}) => {
  
  const history = useHistory();
  const columns = [
    {
      title: <span style={{color: '#fff'}}>Row</span>,
      key: "Row",
      ellipsis: true,
      render: (record) => {
        return <span>{record?.index || 0}</span>;
      },
      width: '20%'
    }, {
      title: <span style={{color: '#fff'}}>Field</span>,
      key: "Field",
      render: (record) => {
        return <span>{record?.field || 'NA' }</span>;
      },
      width: '30%'
    }, {
      title: <span style={{color: '#fff'}}>Description</span>,
      key: "description",
      render: (record) => {
        return <span>{record?.description || 'NA'}</span>;
      },
      width: '60%'
    },
  ];

  return (
    <Modal
      centered
      visible={visible}
      footer={null}
       width={700}
      wrapClassName="importFailModelPOP"
    >
       <div className="importFailModel">
        <div className="text-center pb-3">
          <CustIcon type="close-o" />
        </div>
        <Title level={1} className="text-center">
          Employee Import Failed
        </Title>
        </div>
        <Card className="text-center">
          <Table
            dataSource={errorDetail}
            columns={columns}
          ></Table>
             <div className="pt-2">
        <Button
            type="primary"
            shape="round"
            htmlType="submit"
            style={{width: '10em'}}
            onClick={closeModal}
            block
          >
            OK
          </Button>
          </div>
        </Card>
     
    </Modal>
  );
};
